export const defaultMarkdownLocalizedTexts = {
  MARKDOWN_EXTERNAL_LINK_ALT: "Opens in a new window; external."
};